export const DEFAULT_CURRENCY = 'USD';
export const DEFAULT_PRODUCT_TITLE = 'Product Title';
export const DEFAULT_LOCALE = 'en-us';

export const TAX_OPTIONS = {
    INCLUDED: 'INC',
    EXCLUDED: 'EX',
    BOTH: 'BOTH',
};

export const widgetSelector = (uuid: string): string => `#bc-product-${uuid}`;
